<template>
    <div class="footer">
        <div class="container">
        <div class="footer-content">

            <div class="footer-right">
                  <div class="company">上海宅易丞鲸致网络科技有限公司</div>
                <div class="qrcode-block">
                    <div class="qrcode-item">
                        <img src="https://jzmall.lifejingzhi.com/file/jz-gw/jzsh-xcx.png"/>
                        <div>鲸致生活小程序</div>
                    </div>
                     <div class="qrcode-item">
                        <img src="https://jzmall.lifejingzhi.com/file/jz-gw/jzsh-gzh.png"/>
                        <div>鲸致生活公众号</div>
                    </div>


                </div>
            </div>
              <div class="footer-left">

                <div class="line-one">全国统一客服热线：</div>
                <div class="service-phone">400-5175-8011</div>
                <div>合作鲸致邮箱：mkt@lifejingzhi.com</div>
                <div class="joinus">加入鲸致生活：hr@lifejingzhi.com</div>
                <div class="joinus">地址：上海市浦东新区祖冲之路1505弄100号3幢5楼</div>

            </div>


        </div>
        <div class="tcp">
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=31010402335780" rel="noreferrer" target="_blank">沪公网安备31010402335780号</a>
            沪ICP备 18034149号-2 
            <span class="copyright">copyright©2025 All Rights Reserved</span>
        </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:"Footer",
        data(){
            return {

            }
        },

        created(){

        },
        methods:{

        }
    }
</script>
<style scoped>
.footer{
    /* height: 396px; */
    background: #00BDFF;
    color:#fff;
    padding:40px 0 0;
}
.footer-content{
    display: flex;
    align-items: center;
    justify-content: space-between;
     /* height: 260px; */
     font-size: 14px;
     padding:0 6px 36px 40px;
}
.footer-left{
    flex:1;
    font-size: 16px;
}
.company{
    font-size: 20px;
    margin-bottom:28px;
}
.line-one{
    font-size: 18px;
    line-height: 20px;
}
.service-phone{
    font-size: 30px;
    height: 36px;
    line-height: 36px;
    font-weight: bold;
    margin:16px 0 36px;
}
.joinus{
    margin-top:14px;
}
.tcp{
   /* padding-top:30px; */
   border-top:1px solid  #EBE6E1;
   text-align: center;
   line-height: 74px;
   height: 74px;
}
.copyright{
    margin-left:8px;
}

.footer-right{
   margin-right:190px;
}
.qrcode-block{
   display: flex;
   /* flex-wrap: wrap;
    width:372px; */
}
.qrcode-item{
    margin-right:40px;
    text-align: center;
    font-size: 16px;
    flex:1;
}
.qrcode-item:last-child{
    /* margin-left:-8px; */
}
.qrcode-item img{
  width:110px;
  height: 110px;
  margin:0 0 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue